import React from 'react'

const FKlogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        fill="#FCD20A"
        fillRule="evenodd"
        d="M18.494.667l-.606.251a.394.394 0 00-.27.402v1.8H2.382V1.322a.392.392 0 00-.27-.402L1.506.67s-.168-.113.048-.208l1.062-.4a1.2 1.2 0 01.415-.05h13.956c.136-.007.273.01.403.05l1.062.4c.21.093.042.205.042.205z"
        clipRule="evenodd"
      />
      <path
        fill="#FBE801"
        fillRule="evenodd"
        d="M18.494.667l-1.11-.414a1.414 1.414 0 00-.405-.065H3.023c-.13.001-.26.024-.384.069L1.506.659s-.168-.112.048-.207l1.062-.4a1.2 1.2 0 01.415-.05h13.956c.136-.007.273.01.403.05l1.062.4c.21.103.042.215.042.215z"
        clipRule="evenodd"
      />
      <path
        fill="#F0A123"
        fillRule="evenodd"
        d="M1.444.574v1.617l1-.647s.191-.53-.284-.74l-.716-.23z"
        clipRule="evenodd"
      />
      <path
        fill="#F7DE03"
        fillRule="evenodd"
        d="M1.444.574v.098l.708.232c.388.139.284.64.284.64s.19-.53-.284-.74l-.708-.23z"
        clipRule="evenodd"
      />
      <path
        fill="#F0A123"
        fillRule="evenodd"
        d="M17.846.802c-.473.207-.284.742-.284.742l.994.647V.574l-.71.228z"
        clipRule="evenodd"
      />
      <path
        fill="#F7DE03"
        fillRule="evenodd"
        d="M17.846.804c-.473.208-.284.74-.284.74s-.104-.501.284-.64l.71-.232V.574l-.71.23z"
        clipRule="evenodd"
      />
      <path
        fill="url(#paint0_linear_329_6746)"
        fillRule="evenodd"
        d="M20 3.033v15.866A1.103 1.103 0 0118.888 20H1.11A1.106 1.106 0 010 18.9V3.032h20z"
        clipRule="evenodd"
      />
      <path fill="#F7F3B7" d="M20 3.118H0v.257h20v-.257z" />
      <path
        fill="#AF8E2F"
        fillRule="evenodd"
        d="M14.157 1.047a.52.52 0 11.008 1.038.52.52 0 01-.008-1.038z"
        clipRule="evenodd"
      />
      <path
        fill="#937A2D"
        fillRule="evenodd"
        d="M14.157 1.047a.517.517 0 01.515.518.487.487 0 00-.515-.452.484.484 0 00-.514.452.515.515 0 01.514-.518z"
        clipRule="evenodd"
      />
      <path
        fill="#AF8E2F"
        fillRule="evenodd"
        d="M5.843 1.047a.52.52 0 11.004 1.038.52.52 0 01-.004-1.038z"
        clipRule="evenodd"
      />
      <path
        fill="#937A2D"
        fillRule="evenodd"
        d="M5.843 1.047a.517.517 0 01.514.518.487.487 0 00-.514-.452.484.484 0 00-.517.452.516.516 0 01.517-.518z"
        clipRule="evenodd"
      />
      <path
        fill="url(#paint1_radial_329_6746)"
        d="M2.905 3.401H0v15.983h2.905V3.401z"
        opacity="0.2"
      />
      <path
        fill="url(#paint2_radial_329_6746)"
        d="M18.556 3.117H1.444V.671L2.762.226 17.238.22l1.318.45v2.446z"
        opacity="0.5"
      />
      <path
        fill="url(#paint3_radial_329_6746)"
        d="M20 3.401h-2.905v15.983H20V3.401z"
        opacity="0.2"
      />
      <path
        fill="#1C41D6"
        d="M13.856 16.766h1.538c.57 0 .94-.414 1.11-1.347.158-.896-.05-1.296-.623-1.296h-1.537l.24-1.341c.273-1.534 1.08-2.29 2.405-2.29h.254c.734 0 1.139-.119 1.195-.461a2.516 2.516 0 00-.096-.896 3.04 3.04 0 00-.278-.85c-.178-.308-.587-.458-1.23-.458-1.591 0-2.905.436-3.942 1.319-1.038.883-1.683 2.058-1.972 3.659l-.246 1.318H7.455c-.052 0-3.39.371-3.39.371l3.073.463.124.445-1.88.156 1.976.284.079.36-5.893.326 6.411.238h2.24L9.614 20h3.669l.572-3.234z"
      />
      <path
        fill="#B3B5B3"
        d="M16.836 7.827c-1.635 0-2.92.452-3.928 1.317-1.008.864-1.679 2.02-1.967 3.625l-.255 1.354H7.472l-2.538.274 6 .041.028-.207.245-1.395c.282-1.566.931-2.73 1.93-3.587.997-.856 2.15-1.217 3.744-1.217.613 0 1.027-.018 1.187.262-.002-.009-.193-.485-1.232-.467zM9.616 20h.242l.583-3.238h-.247L9.615 20zm6.315-5.877h-1.593l-.065.33h2.193a.56.56 0 00-.535-.33z"
        opacity="0.5"
      />
      <path
        fill="#F6E72F"
        fillRule="evenodd"
        d="M20 2.931l-2.477-1.677V3.12H20V2.93zM0 3.12h2.475V1.254L0 2.931v.189z"
        clipRule="evenodd"
      />
      <path
        fill="#FDD537"
        fillRule="evenodd"
        d="M0 3.074l2.475-1.658v-.162L0 2.937v.137zM20 2.931l-2.477-1.677v.164L20 3.076v-.145z"
        clipRule="evenodd"
      />
      <path
        fill="#F3DB0B"
        d="M2.477 3.033H0v.085h2.477v-.085zM20 3.033h-2.477v.085H20v-.085z"
      />
      <path
        fill="url(#paint4_linear_329_6746)"
        fillRule="evenodd"
        d="M14.86 4.334a.485.485 0 11-.969.004.485.485 0 01.97-.004z"
        clipRule="evenodd"
      />
      <path
        fill="url(#paint5_linear_329_6746)"
        fillRule="evenodd"
        d="M6.05 4.351a.468.468 0 11-.936 0 .468.468 0 01.937 0z"
        clipRule="evenodd"
      />
      <g filter="url(#filter0_f_329_6746)" opacity="0.25">
        <path
          fill="#000"
          d="M5.4 4.372a4.588 4.588 0 004.584 4.82 4.588 4.588 0 004.584-4.82h-.533A4.056 4.056 0 019.984 8.66a4.056 4.056 0 01-4.05-4.29H5.4z"
        />
      </g>
      <g filter="url(#filter1_i_329_6746)">
        <path
          fill="#fff"
          d="M9.987 8.302a5.026 5.026 0 01-3.223-1.14C5.895 6.436 5.4 5.466 5.4 4.498a.636.636 0 01.141-.483.355.355 0 01.396.058s.092.035.092.207v.253c0 1.694 1.842 3.147 3.955 3.147 2.722 0 3.942-1.644 3.942-3.176 0 0-.098-.352.126-.51.585-.161.521.506.521.506a3.521 3.521 0 01-1.201 2.656c-.838.75-2.005 1.146-3.384 1.146z"
        />
      </g>
      <mask
        id="mask0_329_6746"
        style={{ maskType: 'alpha' }}
        width="10"
        height="6"
        x="5"
        y="3"
        maskUnits="userSpaceOnUse"
      >
        <path
          fill="#fff"
          d="M9.987 8.302a5.026 5.026 0 01-3.223-1.14C5.895 6.436 5.4 5.466 5.4 4.498a.636.636 0 01.141-.483.355.355 0 01.396.058s.092.035.092.207v.253c0 1.694 1.842 3.147 3.955 3.147 2.722 0 3.942-1.644 3.942-3.176 0 0-.098-.352.126-.51.585-.161.521.506.521.506a3.521 3.521 0 01-1.201 2.656c-.838.75-2.005 1.146-3.384 1.146z"
        />
      </mask>
      <g mask="url(#mask0_329_6746)" opacity="0.4">
        <path
          fill="#A6A7AB"
          d="M6.148 4.363a1.115 1.115 0 00-.909-.07l-.022-.058a1.167 1.167 0 01.964.074l-.033.054zM5.254 4.877l-.033-.052a1.16 1.16 0 01.96-.114l-.022.058a1.126 1.126 0 00-.905.108zM5.472 5.462l-.044-.046a1.168 1.168 0 01.921-.298l-.01.062a1.115 1.115 0 00-.867.282zM5.655 5.987l-.046-.042a1.154 1.154 0 01.898-.359v.063a1.121 1.121 0 00-.852.338zM5.929 6.507l-.054-.031a1.165 1.165 0 01.809-.529v.062a1.119 1.119 0 00-.755.498zM6.31 6.928l-.056-.03a1.174 1.174 0 01.782-.567v.062a1.117 1.117 0 00-.726.535zM6.713 7.311l-.058-.025a1.167 1.167 0 01.736-.622l.013.06a1.112 1.112 0 00-.691.587zM7.138 7.715l-.06-.014a1.162 1.162 0 01.597-.759L7.702 7a1.122 1.122 0 00-.564.715zM7.706 7.974h-.062a1.16 1.16 0 01.438-.862l.035.052a1.11 1.11 0 00-.41.81zM8.144 8.22a1.156 1.156 0 01.382-.89l.037.047a1.124 1.124 0 00-.357.83l-.062.012zM8.709 8.406a1.154 1.154 0 01.207-.946l.048.04a1.115 1.115 0 00-.187.891l-.068.015zM9.335 8.397a1.162 1.162 0 01.01-.968l.057.031a1.108 1.108 0 000 .91l-.067.027zM9.935 8.538a1.146 1.146 0 01-.173-.95l.059.02a1.12 1.12 0 00.163.895l-.05.035zM10.464 8.526a1.161 1.161 0 01-.185-.95l.058.019a1.126 1.126 0 00.177.893l-.05.038zM10.962 8.433a1.16 1.16 0 01-.133-.956l.06.02a1.107 1.107 0 00.125.9l-.052.036zM11.516 8.35a1.155 1.155 0 01-.207-.948l.06.019a1.124 1.124 0 00.184.891l-.037.038zM12.085 8.18a1.153 1.153 0 01-.378-.89h.062a1.117 1.117 0 00.357.83l-.041.06zM12.568 7.887a1.167 1.167 0 01-.415-.868h.062a1.112 1.112 0 00.4.829l-.047.04zM13.027 7.554a1.16 1.16 0 01-.492-.83h.062a1.114 1.114 0 00.465.784l-.035.046zM13.504 7.21a1.145 1.145 0 01-.643-.72l.06-.014a1.117 1.117 0 00.608.678l-.025.056zM13.869 6.704c-.027 0-.69-.129-.911-.595l.056-.03c.207.44.859.56.867.56l-.012.065zM14.32 6.28c-.032 0-.727-.117-.978-.567l.054-.033c.239.427.925.539.932.539l-.009.062zM14.44 5.732a1.138 1.138 0 01-.855-.363l.047-.04a1.127 1.127 0 00.847.34v.063h-.04zM14.377 5.153a1.192 1.192 0 01-.743-.222l.038-.047c.384.302.996.182 1.002.18l.02.06c-.104.02-.21.03-.317.03zM14.22 4.658c-.169 0-.336-.026-.497-.077l.02-.058c.297.099.618.099.916 0l.027.056a1.22 1.22 0 01-.467.079zM14.157 4.206a1.319 1.319 0 01-.469-.083l.023-.058c.297.104.62.104.917 0l.023.058a1.4 1.4 0 01-.494.083z"
        />
        <path
          fill="#fff"
          d="M6.18 4.392a1.13 1.13 0 00-.918-.072l-.017-.044a1.176 1.176 0 01.957.077l-.023.04zM5.285 4.908l-.027-.039a1.183 1.183 0 01.955-.114l-.017.046a1.132 1.132 0 00-.911.107zM5.5 5.493l-.032-.033a1.177 1.177 0 01.915-.297v.046a1.123 1.123 0 00-.882.284zM5.683 6.022l-.035-.031a1.175 1.175 0 01.89-.355v.046a1.136 1.136 0 00-.855.34zM5.955 6.542l-.04-.025a1.17 1.17 0 01.806-.524v.047a1.121 1.121 0 00-.766.502zM6.337 6.963l-.041-.023a1.186 1.186 0 01.776-.566v.048a1.123 1.123 0 00-.735.54zM6.74 7.344l-.044-.019a1.18 1.18 0 01.73-.621l.01.045a1.131 1.131 0 00-.696.595zM7.165 7.753l-.046-.01a1.173 1.173 0 01.594-.755l.02.041a1.13 1.13 0 00-.568.724zM7.733 8.012h-.047a1.172 1.172 0 01.435-.856l.027.037a1.122 1.122 0 00-.415.819zM8.186 8.256a1.174 1.174 0 01.378-.883l.03.038a1.123 1.123 0 00-.362.843l-.046.002zM8.75 8.44a1.176 1.176 0 01.197-.938l.037.029a1.119 1.119 0 00-.188.9l-.046.01zM9.375 8.43a1.172 1.172 0 01.012-.96l.042.024a1.129 1.129 0 00-.01.918l-.044.019zM9.977 8.573a1.173 1.173 0 01-.173-.945l.044.015a1.112 1.112 0 00.166.901l-.037.03zM10.506 8.559a1.174 1.174 0 01-.185-.943l.043.014a1.121 1.121 0 00.179.9l-.037.029zM11.004 8.466a1.176 1.176 0 01-.131-.95l.041.015a1.128 1.128 0 00.129.91l-.04.025zM11.586 8.37a1.11 1.11 0 01-.226-.928l.046.014a1.055 1.055 0 00.218.885l-.038.03zM12.16 8.205a1.135 1.135 0 01-.416-.875h.048a1.075 1.075 0 00.394.829l-.027.046zM12.647 7.869a1.036 1.036 0 01-.461-.83h.048a.977.977 0 00.438.778l-.025.052zM13.132 7.558s-.535-.286-.562-.8h.042c.024.487.53.758.535.76l-.015.04zM13.65 7.224c-.026-.01-.623-.244-.75-.742l.048-.012c.118.474.712.706.718.709l-.017.045zM13.975 6.66c-.031 0-.751-.124-.971-.589l.043-.018c.208.441.928.56.934.562l-.006.045zM14.328 6.275l-.087-.036c-.208-.083-.687-.273-.8-.474l.042-.023c.104.186.575.375.774.454.112.043.114.045.108.068a.025.025 0 01-.016.014.025.025 0 01-.021-.003zM14.516 5.76v-.033l-.16-.041c-.245-.06-.622-.153-.728-.284l.035-.031c.102.12.48.207.706.271.226.065.222.054.22.085-.003.031-.042.031-.073.034zM14.616 5.143v-.027l-.185-.015c-.249-.014-.622-.037-.75-.137l.028-.037c.114.091.496.114.724.129.229.014.239.014.243.045.004.031-.037.035-.06.042zM14.207 4.716a.94.94 0 01-.45-.106l.02-.041a1.136 1.136 0 00.92 0l.02.043a1.375 1.375 0 01-.51.104zM14.174 4.258a.972.972 0 01-.45-.106l.02-.042a1.134 1.134 0 00.92 0l.02.042c-.161.07-.335.105-.51.106z"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_329_6746"
          width="10.999"
          height="6.64"
          x="4.485"
          y="3.462"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            result="effect1_foregroundBlur_329_6746"
            stdDeviation="0.455"
          />
        </filter>
        <filter
          id="filter1_i_329_6746"
          width="9.18"
          height="4.333"
          x="5.394"
          y="3.969"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2.083" />
          <feComposite
            in2="hardAlpha"
            k2="-1"
            k3="1"
            operator="arithmetic"
          />
          <feColorMatrix values="0 0 0 0 0.733333 0 0 0 0 0.737255 0 0 0 0 0.745098 0 0 0 0.6 0" />
          <feBlend in2="shape" result="effect1_innerShadow_329_6746" />
        </filter>
        <linearGradient
          id="paint0_linear_329_6746"
          x1="9.999"
          x2="9.999"
          y1="20"
          y2="3.033"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.01" stopColor="#FFCC04" />
          <stop offset="0.4" stopColor="#F6E72F" />
          <stop offset="1" stopColor="#F6E72F" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_329_6746"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(0 -11.9361 3.79824 0 -.083 11.475)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F5A620" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_329_6746"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(0 2.17664 -15.6984 0 9.96 3.128)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F4A41F" />
          <stop offset="1" stopColor="#fff" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_329_6746"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(0 -12.0233 3.82601 0 19.92 11.42)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F5A620" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id="paint4_linear_329_6746"
          x1="14.377"
          x2="14.377"
          y1="3.905"
          y2="4.882"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F6E72F" />
          <stop offset="1" stopColor="#F5A620" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_329_6746"
          x1="5.584"
          x2="5.584"
          y1="3.935"
          y2="4.878"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F6E72F" />
          <stop offset="1" stopColor="#F5A620" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default FKlogo
